export default {
    flights: [],
    visitId: null,
    visit: null,
};
